import { render } from "./SurvivalChart.vue?vue&type=template&id=b58e1546&scoped=true"
import script from "./SurvivalChart.vue?vue&type=script&lang=js"
export * from "./SurvivalChart.vue?vue&type=script&lang=js"

import "./SurvivalChart.vue?vue&type=style&index=0&id=b58e1546&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58e1546"]])

export default __exports__